// ─────────────────────────────────────────────────────────────────────────────
// Replace all placeholder values with your actual AWS resource identifiers.
// Do NOT commit real credentials to source control — use environment variables
// or AWS Secrets Manager for production deployments.
// ─────────────────────────────────────────────────────────────────────────────


const awsExports = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
    },
  },
};

export default awsExports;
